// extracted by mini-css-extract-plugin
export default {"container":"Text_container_FtkIx","textMessage":"Text_textMessage_G1Cv6","showOriginal":"Text_showOriginal_JpZPx","green":"Text_green_2_5nW"};